module.exports = __webpack_public_path__ + "img/smart_element.fed61771.svg";